import React from 'react'
import reactStamp from 'react-stamp'
import './home.css'

export default reactStamp(React).compose({

    render() {

        let classes = '';

        if (this.props.single) {
            classes = "patient-avatar single-avatar"
        } else {
            classes = "patient-avatar"
        }

        return (
            <div className={classes}>
                <img className="photo" src={this.props.src}/>
            </div>
        )
    }

});



/** WEBPACK FOOTER **
 ** ./src/app/components/Home/PatientPhoto.js
 **/